import React, { useEffect, useRef } from "react";
import "./register.css";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import { AcknowledgementModal } from "../../components/Modals/AcknowledgementModal/acknowledgement-modal";
import Navbar from "../../components/navbar/navbar";

function Thanks() {
  const router = useNavigate();
  const username = useRef(null);
  const registration_url_params = useRef(null);

  useEffect(() => {
    // Parse the query string using URLSearchParams
    let params = new URLSearchParams(window.location.search);
    // Access the parameters
    let _username = params.get("id");
    if (!_username) {
      router("/");
    }
    username.current = _username;
    registration_url_params.current = params.get("registered");
  }, []);

  function VerificationStep() {
    let url_append = registration_url_params.current ? `&registered=true` : "";
    router(`/email-verification?id=${username.current}${url_append}`);
  }

  return (
    <>
      <section className="thanks-page-bg">
        <Navbar />
        <AcknowledgementModal id="thanks-for-registering" showDivider={true} header="Thanks For Creating an Account!" message={"You will need to verify your email address before you can sign in."} isActive={true} animate={false} buttonText={"Continue"} onAcknowledge={VerificationStep} />
        <Footer />
      </section>
    </>
  );
}

export default Thanks;
